export default __webpack_public_path__ + "static/media/hot-icon.65dcad61.webp";